import {Button, Form, Input, Modal, ModalProps, Space} from "antd";
import useAntTable from "../../utils/useAntTable";
import * as api from "../../apis/product";
import StandardTable, {StandardColumnsType} from "../StandardTable";
import {RowSelectionType, TableRowSelection} from "antd/lib/table/interface";
import {useEffect, useState} from "react";
import * as React from "react";


interface ProductSelectModalProps extends ModalProps {
    multiple?: boolean
    columns?: StandardColumnsType
    onComplete?: (keys?: number[], records?: any[]) => void
    url?: string
    queryParams?: any
    searchColumns?:StandardColumnsType
}

function ProductSelectModal(props: ProductSelectModalProps) {
    const {onCancel, onOk, onComplete, columns = [], ...otherProps} = props;
    const {tableProps, form, search} = useAntTable(props.url?props.url:api.getProducts, {selectTable: props.multiple?true:'radio', defaultParams:{...props?.queryParams||{status: true}}});
    useEffect(()=>{
        form.setFieldsValue(props.queryParams);
        search.submit();
    },[props.queryParams]);
    const tableColumns = columns.length ? columns : [
        {
            dataIndex: 'code',
            title: '商品编号'
        },
        {
            dataIndex: 'name',
            title: '商品名称'
        },
        {
            dataIndex: 'specification',
            title: '规格型号'
        },
        {
            dataIndex: 'categoryName',
            title: '产品线',
            render: (value?: string) => value?.replace("//", '')?.replaceAll('/', ' / ')
        },
        {
            dataIndex: 'unit',
            title: '单位'
        }
    ];
    const searchColumns = props.searchColumns? props.searchColumns:[
        {

        }
    ]

    useEffect(() => {
        if(otherProps){
            resetSelected()
        }
    }, [otherProps.open]);

    const handleOk = (e: React.MouseEvent<HTMLButtonElement>) => {
        onOk && onOk(e)
        onComplete && onComplete(tableProps?.rowSelection?.selectedRowKeys, tableProps?.rowSelection?.selectedRows);
    }
    const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
        onCancel && onCancel(e);
    }

    const resetSelected = ()=>{
        tableProps?.rowSelection?.onChange([],[]);
    }

    const toolbar =
        <Space style={{flex:1}}>
            <Form form={form} disabled={false}>
                <Space>
                    <Form.Item name={'code'} style={{marginBottom: 0}}>
                        <Input placeholder={'请输入商品编号或名称'} allowClear/>
                    </Form.Item>
                    <Button onClick={search.reset}>重置</Button>
                    <Button type={"primary"} onClick={search.submit} loading={tableProps.loading}>搜索</Button>
                </Space>
            </Form>
        </Space>

    return <Modal  title={'商品选择'} {...otherProps} width={1000} onOk={handleOk} onCancel={handleCancel} destroyOnClose>
        <StandardTable {...tableProps} rowKey={'id'} submit={search.submit} form={form}
                       columns={tableColumns} search={search} extSearchColumns={props.searchColumns}
                       toolbar={props.searchColumns?undefined:toolbar}
        />
    </Modal>
}

export default ProductSelectModal;